import { render, staticRenderFns } from "./consititution.vue?vue&type=template&id=b94b169c"
import script from "./consititution.vue?vue&type=script&lang=js"
export * from "./consititution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports